module.exports = __webpack_public_path__ + "img/icon-pay-card-usa.b19238f3.svg";